/**
 * Alternative markdown syntax for collapsible sections that works better
 * with standard markdown parsers. Converts custom syntax to proper HTML.
 */
export function preprocessCollapsibleMarkdown(content: string): string {
  // Convert custom collapsible syntax to standard HTML that will render properly
  return content.replace(/(?:^|\n)((?:\s*>.*\n?)+)/gm, (match, blockquoteContent) => {
    // Check if this looks like a collapsible section
    const lines = blockquoteContent
      .split('\n')
      .map((line: string) => line.replace(/^\s*>\s?/, '').trim())
      .filter(Boolean)

    if (
      (lines.length > 0 && lines[0].includes('📋')) ||
      lines[0].toLowerCase().includes('details') ||
      lines[0].toLowerCase().includes('expand')
    ) {
      const title = lines[0]
      const content = lines.slice(1).join('\n\n')

      return `\n<details>\n<summary>${title}</summary>\n\n${content}\n\n</details>\n`
    }

    return match
  })
}

/**
 * Shared rehype rewrite function for markdown processing
 * Removes anchor links from headings
 */
export const sharedRehypeRewrite = (node: any, _: any, parent: any) => {
  if (
    'tagName' in node &&
    node.tagName === 'a' &&
    parent &&
    'tagName' in parent &&
    /^h(1|2|3|4|5|6)/.test(parent.tagName)
  ) {
    parent.children = parent.children.slice(1)
  }
}
